module.exports = __webpack_public_path__ + "static/media/strong.017db40f.png";